// import node module libraries
import React, { Fragment, useState } from 'react';
import { Col, Row, Tab, Card, Nav, Badge } from 'react-bootstrap';

// import sub custom components
import CoursesTable from './CoursesTable';

import { useQuery } from '@apollo/client/react';
import { GET_ALL_COURSES } from 'helper/graphql/queries';

const AllCourses = () => {
	const [courses, setCourses] = useState([]);
	
	useQuery(
		GET_ALL_COURSES,
		{
			onCompleted: (data) => {
				const _courses = data?.allCourses?.edges?.map(item => item.node);
				setCourses(_courses.filter(item => item.status !== 'Draft'))
			}
		}
	);

	const approvedCount = courses.filter(item => item.status.toLowerCase() === 'active').length;
	const pendingCount = courses.filter(item => item.status.toLowerCase() === 'submitted').length;
	const rejectedCount = courses.filter(item => item.status.toLowerCase() === 'rejected').length;

	return (
		<Fragment>
			{/* Page Header */}
			{/* <div className="admin-page-header mb-4">
				<Row className="align-items-center">
					<Col lg={8} md={12}>
						<div className="header-content">
							<h1 className="page-title mb-2">
								<i className="fe fe-book-open me-3"></i>
								Course Management
							</h1>
							<p className="page-description mb-0">
								Review, approve, and manage all courses on the platform
							</p>
						</div>
					</Col>
					<Col lg={4} md={12} className="text-lg-end mt-3 mt-lg-0">
						<div className="header-stats">
							<div className="stat-badge">
								<i className="fe fe-layers me-2"></i>
								<span className="stat-label">Total:</span>
								<span className="stat-value">{courses.length}</span>
							</div>
						</div>
					</Col>
				</Row>
			</div> */}

			{/* Stats Cards */}
			<Row className="g-3 mb-4">
				<Col lg={3} md={6} sm={12}>
					<Card className="stats-card-admin stats-all">
						<Card.Body className="p-4">
							<div className="d-flex align-items-center justify-content-between">
								<div>
									<div className="stats-label">All Courses</div>
									<div className="stats-value">{courses.length}</div>
								</div>
								<div className="stats-icon-wrapper stats-icon-all">
									<i className="fe fe-book"></i>
								</div>
							</div>
						</Card.Body>
					</Card>
				</Col>
				<Col lg={3} md={6} sm={12}>
					<Card className="stats-card-admin stats-approved">
						<Card.Body className="p-4">
							<div className="d-flex align-items-center justify-content-between">
								<div>
									<div className="stats-label">Approved</div>
									<div className="stats-value">{approvedCount}</div>
								</div>
								<div className="stats-icon-wrapper stats-icon-approved">
									<i className="fe fe-check-circle"></i>
								</div>
							</div>
						</Card.Body>
					</Card>
				</Col>
				<Col lg={3} md={6} sm={12}>
					<Card className="stats-card-admin stats-pending">
						<Card.Body className="p-4">
							<div className="d-flex align-items-center justify-content-between">
								<div>
									<div className="stats-label">Pending Review</div>
									<div className="stats-value">{pendingCount}</div>
								</div>
								<div className="stats-icon-wrapper stats-icon-pending">
									<i className="fe fe-clock"></i>
								</div>
							</div>
						</Card.Body>
					</Card>
				</Col>
				<Col lg={3} md={6} sm={12}>
					<Card className="stats-card-admin stats-rejected">
						<Card.Body className="p-4">
							<div className="d-flex align-items-center justify-content-between">
								<div>
									<div className="stats-label">Rejected</div>
									<div className="stats-value">{rejectedCount}</div>
								</div>
								<div className="stats-icon-wrapper stats-icon-rejected">
									<i className="fe fe-x-circle"></i>
								</div>
							</div>
						</Card.Body>
					</Card>
				</Col>
			</Row>

			{/* Main Content */}
			<Row>
				<Col lg={12} md={12} sm={12}>
					<Tab.Container defaultActiveKey="all">
						<Card className="courses-table-card">
							<Card.Header className="table-card-header">
								<Nav className="modern-tab-nav">
									<Nav.Item>
										<Nav.Link eventKey="all" className="modern-tab-link">
											All Courses
											<Badge bg="" className="count-badge ms-2">{courses.length}</Badge>
										</Nav.Link>
									</Nav.Item>
									<Nav.Item>
										<Nav.Link eventKey="approved" className="modern-tab-link">
											Approved
											<Badge bg="" className="count-badge count-badge-success ms-2">{approvedCount}</Badge>
										</Nav.Link>
									</Nav.Item>
									<Nav.Item>
										<Nav.Link eventKey="pending" className="modern-tab-link">
											Pending
											<Badge bg="" className="count-badge count-badge-warning ms-2">{pendingCount}</Badge>
										</Nav.Link>
									</Nav.Item>
									<Nav.Item>
										<Nav.Link eventKey="rejected" className="modern-tab-link">
											Rejected
											<Badge bg="" className="count-badge count-badge-danger ms-2">{rejectedCount}</Badge>
										</Nav.Link>
									</Nav.Item>
								</Nav>
							</Card.Header>
							<Card.Body className="p-0">
								<Tab.Content>
									<Tab.Pane eventKey="all" className="pb-4">
										<CoursesTable courses_data={courses} />
									</Tab.Pane>
									<Tab.Pane eventKey="approved" className="pb-4">
										<CoursesTable courses_data={courses.filter(item => item.status.toLowerCase() === 'active')} />
									</Tab.Pane>
									<Tab.Pane eventKey="pending" className="pb-4">
										<CoursesTable courses_data={courses.filter(item => item.status.toLowerCase() === 'submitted')} />
									</Tab.Pane>
									<Tab.Pane eventKey="rejected" className="pb-4">
										<CoursesTable courses_data={courses.filter(item => item.status.toLowerCase() === 'rejected')} />
									</Tab.Pane>
								</Tab.Content>
							</Card.Body>
						</Card>
					</Tab.Container>
				</Col>
			</Row>

			<style jsx>{`
				/* Page Header */
				.admin-page-header {
					background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
					padding: 2rem;
					border-radius: 16px;
					border-left: 4px solid #F68521;
				}

				.header-content {
					/* Styles handled by children */
				}

				.page-title {
					font-size: 2rem;
					font-weight: 800;
					color: #1e293b;
					display: flex;
					align-items: center;
				}

				.page-description {
					font-size: 1rem;
					color: #64748b;
				}

				.header-stats {
					display: flex;
					justify-content: flex-end;
				}

				.stat-badge {
					background: white;
					padding: 1rem 1.5rem;
					border-radius: 12px;
					box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
					display: flex;
					align-items: center;
					gap: 0.5rem;
					font-size: 0.9375rem;
				}

				.stat-badge i {
					color: #F68521;
					font-size: 1.25rem;
				}

				.stat-label {
					color: #64748b;
					font-weight: 500;
				}

				.stat-value {
					color: #1e293b;
					font-weight: 800;
					font-size: 1.125rem;
				}

				/* Stats Cards */
				.stats-card-admin {
					border: none;
					border-radius: 12px;
					transition: all 0.3s ease;
					position: relative;
					overflow: hidden;
				}

				.stats-card-admin::before {
					content: '';
					position: absolute;
					top: 0;
					left: 0;
					width: 4px;
					height: 100%;
					background: currentColor;
				}

				.stats-card-admin:hover {
					transform: translateY(-4px);
					box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
				}

				.stats-all::before {
					background: #1d9eb0;
				}

				.stats-approved::before {
					background: #10b981;
				}

				.stats-pending::before {
					background: #fbbf24;
				}

				.stats-rejected::before {
					background: #ef4444;
				}

				.stats-label {
					font-size: 0.8125rem;
					color: #94a3b8;
					font-weight: 600;
					text-transform: uppercase;
					letter-spacing: 0.5px;
					margin-bottom: 0.5rem;
				}

				.stats-value {
					font-size: 2rem;
					font-weight: 800;
					color: #1e293b;
				}

				.stats-icon-wrapper {
					width: 56px;
					height: 56px;
					display: flex;
					align-items: center;
					justify-content: center;
					border-radius: 12px;
					font-size: 1.75rem;
				}

				.stats-icon-all {
					background: rgba(29, 158, 176, 0.1);
					color: #1d9eb0;
				}

				.stats-icon-approved {
					background: rgba(16, 185, 129, 0.1);
					color: #10b981;
				}

				.stats-icon-pending {
					background: rgba(251, 191, 36, 0.1);
					color: #fbbf24;
				}

				.stats-icon-rejected {
					background: rgba(239, 68, 68, 0.1);
					color: #ef4444;
				}

				/* Courses Table Card */
				.courses-table-card {
					border: none;
					border-radius: 16px;
					box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
					overflow: hidden;
				}

				.table-card-header {
					background: white;
					border-bottom: 2px solid #f1f5f9;
					padding: 0;
				}

				/* Modern Tabs */
				.modern-tab-nav {
					padding: 0.75rem 1.5rem;
					gap: 0.5rem;
					background: #f8fafc;
					flex-wrap: wrap;
				}

				.modern-tab-link {
					padding: 0.875rem 1.5rem !important;
					border-radius: 10px !important;
					border: 2px solid transparent !important;
					font-weight: 600 !important;
					font-size: 0.9375rem !important;
					color: #64748b !important;
					transition: all 0.3s ease !important;
					display: flex !important;
					align-items: center !important;
					background: transparent !important;
				}

				.modern-tab-link:hover {
					background: white !important;
					color: #F68521 !important;
					border-color: #f1f5f9 !important;
				}

				.modern-tab-link.active {
					background: linear-gradient(135deg, #F68521 0%, #1d9eb0 100%) !important;
					color: white !important;
					border-color: transparent !important;
					box-shadow: 0 4px 12px rgba(246, 133, 33, 0.3) !important;
				}

				.modern-tab-link.active .count-badge {
					background: rgba(255, 255, 255, 0.25) !important;
					color: white !important;
				}

				/* Count Badges */
				.count-badge {
					padding: 4px 10px;
					border-radius: 8px;
					font-size: 0.75rem;
					font-weight: 700;
					background: rgba(100, 116, 139, 0.1) !important;
					color: #64748b !important;
				}

				.count-badge-success {
					background: rgba(16, 185, 129, 0.1) !important;
					color: #10b981 !important;
				}

				.count-badge-warning {
					background: rgba(251, 191, 36, 0.1) !important;
					color: #fbbf24 !important;
				}

				.count-badge-danger {
					background: rgba(239, 68, 68, 0.1) !important;
					color: #ef4444 !important;
				}

				/* Responsive */
				@media (max-width: 991px) {
					.page-title {
						font-size: 1.5rem;
					}

					.admin-page-header {
						padding: 1.5rem;
					}

					.header-stats {
						justify-content: flex-start;
						margin-top: 1rem;
					}
				}

				@media (max-width: 768px) {
					.stats-value {
						font-size: 1.75rem;
					}

					:global(.modern-tab-nav) {
						padding: 0.5rem 1rem;
					}

					:global(.modern-tab-link) {
						padding: 0.75rem 1rem !important;
						font-size: 0.875rem !important;
					}
				}
			`}</style>
		</Fragment>
	);
};

export default AllCourses;